var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('v-container', [_c('div', {
    staticClass: "mx-auto"
  }, [_c('v-row', {
    staticClass: "line-height-0",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/logo/motie-logo.png"
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/logo/kiat-logo.png"
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/logo/kea-logo.png"
    }
  })])], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mt-10 mt-sm-20 mt-md-40"
  }, [_c('ul', {
    staticClass: "footer-info"
  }, [_vm._l(_vm.info, function (item) {
    return _c('li', {
      key: item._id
    }, [_c('span', [_vm._v(_vm._s(item.term))]), _vm._v(" " + _vm._s(item.desc) + " ")]);
  }), _c('li', [_vm._v("우편번호 03924")]), _c('li', [_vm._v(" 주소 서울특별시 마포구 월드컵북로 54길 11(상암동1599) 전자회관 2층, 11~12층 ")]), _c('li', [_vm._v("사업자등록번호 220-82-00143")]), _c('li', [_vm._v("Tel 02-6388-6154")])], 2)]), _c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v(" Copyright by KOREA ELECTRONICS ASSOCIATION. All Rights reserved. ")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }